import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../../../app/store";
import {User} from "../../../../services/UsersService";

interface AnonymizeUserModalState {
  isOpened: boolean;
  user: User | null;
  isEmailChecked: boolean;
}

const initialState: AnonymizeUserModalState = {
  isOpened: false,
  user: null,
  isEmailChecked: false
};

const anonymizeUserModalSlice = createSlice({
  name: "anonymizeUserModal",
  initialState,
  reducers: {
    open: (state, action: PayloadAction<User>) => {
      state.isOpened = true;
      state.user = action.payload;
    },
    close: () => initialState,
    setEmailChecked: (state, action: PayloadAction<boolean>) => {
      state.isEmailChecked = action.payload;
    }
  }
});

export default anonymizeUserModalSlice.reducer;

export const {open, close, setEmailChecked} = anonymizeUserModalSlice.actions;
export const anonymizeUserModalState = (state: RootState): AnonymizeUserModalState => state.anonymizeUserModal;
